var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRequests = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L22 0 22 22 0 22z",
  transform: "translate(-43 -630) translate(43 630)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6D6D78",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M19.048 5.084L13.45 18.136c-.15.39-.448.711-.837.891-.218.102-.448.153-.687.153-.636 0-1.218-.373-1.485-.948l-.874-1.889-.34-.733h-.006l-.248-.529h.006l-.767-1.618-2.259-.904-2.203-1.019c-.397-.184-.697-.512-.848-.922-.15-.41-.132-.854.05-1.25.18-.39.501-.688.902-.84l13.042-5.594c.205-.088.421-.132.642-.132.43 0 .85.173 1.153.476l.009.008.001.001c.474.476.61 1.18.346 1.797z",
  transform: "translate(-43 -630) translate(43 630)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6D6D78",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.222 15.61H7.565c-.658 0-1.193-.536-1.193-1.193l-.001-1.69 1.842.736.761 1.618.248.529zM8.213 13.463L18.693 3.278",
  transform: "translate(-43 -630) translate(43 630)"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRequests);
export default ForwardRef;